import config from '@/config'
import { requests } from './BaseService'

export type VoiceAiAgentSummary = {
  id: string
  name: string
  isDeleted?: boolean
  isActive?: boolean
  agentStatus?: string
}

export type VoiceAiOutboundConsent = {
  consentGiven: boolean
  selfCertifiedConsentGiven?: boolean
}

export type LocationPhoneNumber = {
  phoneNumber: string
  friendlyName?: string
}

export const VoiceAiReminderService = {
  getAgents: (locationId: string): Promise<{ data: VoiceAiAgentSummary[] }> =>
    requests(config.voiceAiApiUrl).get('/agents/simple', { params: { locationId } }),

  getOutboundConsent: (locationId: string): Promise<{ data: VoiceAiOutboundConsent }> =>
    requests(config.voiceAiApiUrl).get(`/consent/outbound/${locationId}`),

  acceptOutboundTerms: (locationId: string): Promise<{ data: VoiceAiOutboundConsent }> =>
    requests(config.voiceAiApiUrl).post('/consent/outbound', { locationId, consentGiven: true }),

  getLocationNumbers: (locationId: string): Promise<{ data: { numbers: LocationPhoneNumber[] } }> =>
    requests().get(`/phone-system/numbers/location/${locationId}`, {
      params: { pageSize: 1000, page: 0 },
    }),
}
